<div class="page-data">
    <div class="p-relative c-table">
        <app-loader [isLoading]="customFieldsTableService.loading()" />
        <app-common-table
            [config]="tableConfig"
            [service]="customFieldsTableService"
            (actions)="applyAction($event)"
        >
        </app-common-table>
    </div>
</div>

